import React, { useEffect, useState } from "react";
import api from "../../Utils/api";
//import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "react-bootstrap";

import Swal from "sweetalert2";
import { ISOToDateTime } from "../../Components/Common/Common";
//import UserSetting from "../../UserSettings.json";
//import { SlideshowLightbox } from "lightbox.js-react";
//import "lightbox.js-react/dist/index.css";
//import StoneHistorypopup from "../Stone History Popup/StoneHistorypopup";
import { toFixedTwo } from "../../Utils/commonfunctions"

function DeleteProcess() {
const [lotNo, setLotNo] = useState("");
 const [stoneProcessNo, setStoneProcessNo] = useState("");
  const [listStones, setListStones] = useState([]);
  const [listStonesForHistory, setListStonesForHistory] = useState([]);
  // const [stoneHistory, setStoneHistory] = useState([]);

  //const [isModalOpenStone, setIsModalOpenStone] = useState(false);
//   const [isModalStonLotData, setIsModalStonLotData] = useState(false);

  //Image Viewer
 
  const [BatchNo, setBatchNo] = useState("");
  
  const [userDeletepermission, setUserDeletepermission] = useState(null);

  const handleCloseModal = () => {
    //setIsModalOpenStone(false);
   
  };

  useEffect(() => { getUserDeletePermissionCheck(); }, []);

  const getUserDeletePermissionCheck = () => {
    api
      .get("User/AllUserWise")
      .then((result) => {
        var userPermission = result.data.data.deletePermission;
        setUserDeletepermission(userPermission);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearchInputChange = (e) => {
   // setFindNo(e.target.value);
    //setFindNoLabel(e.target.value);
  };

  const DeleteLastStoneProcess = (stoneProcessNo, lotNo) => {
    console.log(stoneProcessNo, lotNo);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        api
          .patch(`Stone/DeleteLotStoneProcess?stoneProcessNo=${stoneProcessNo}&batchNo=${lotNo}`)
          .then((result) => {
            if (result.status === 200) {
                 setLotNo("");
                 setStoneProcessNo("");
              Swal.fire({
                icon: "success",
                title: "Your record has been deleted.",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                 window.location.reload();
              });
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire("Error", "An error occurred.", "error");
          });
      }
    });
  };




  const HandlePop = (batchNo, stoneProcessNo) => {
    debugger
    setBatchNo(batchNo);
    setStoneProcessNo(stoneProcessNo);
   
  };

  return (
    <>
     
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div className="input-group">
            
            </div>
          </div>
        </div>
      
     
        
          <div className="row m-0">
           <div className="row mb-3">
            <div className="col-md-3">
                <label>Lot No</label>
                <input
                type="text"
                className="form-control"
                value={lotNo}
                onChange={(e) => setLotNo(e.target.value)}
                placeholder="Enter Lot No"
                />
            </div>

            <div className="col-md-3">
                <label>Stone Process No</label>
                <input
                type="number"
                className="form-control"
                value={stoneProcessNo}
                onChange={(e) => setStoneProcessNo(e.target.value)}
                placeholder="Enter Stone Process No"
                />
            </div>

            <div className="col-md-2 d-flex align-items-end">
                <Button
                variant="danger"
                onClick={() =>
                    DeleteLastStoneProcess(
                    parseInt(stoneProcessNo),lotNo
                    )
                }
                >
                <i className="fa fa-trash"></i> Delete
                </Button>
            </div>
            </div>
           
          </div>
        

      
    </>
  );
}

export default DeleteProcess;